import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import CaseStudyTemplate from './pages/case-studies/CaseStudyTemplate';
import About from './pages/About';
import AltProjects from './pages/AltProjects';
import NotFound from './pages/NotFound';

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/about" element={<About />} />
        <Route path="/alt-projects" element={<AltProjects />} />
        <Route path="/projects" element={<Navigate to="/" replace />} />
        <Route path="/designing-for-ai-at-google-translate" element={<CaseStudyTemplate />} />
        <Route path="/fish-in-your-ear" element={<CaseStudyTemplate />} />
        <Route path="/scrolling-in-money" element={<CaseStudyTemplate />} />
        <Route path="/talking-to-strangers" element={<CaseStudyTemplate />} />
        <Route path="/the-arsenal-of-startups" element={<CaseStudyTemplate />} />
        <Route path="/designing-a-festival" element={<CaseStudyTemplate />} />
        <Route path="/illustrations" element={<CaseStudyTemplate />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default AppRouter; 